module.exports = __webpack_public_path__ + "@/assets/img/dashboard-due-alert.448c301b.png";